<div class="container">
  <div class="header">
    <button class="btn btn-link back-button" (click)="backToOfflinePatients()">
      <i class="pi pi-arrow-left"></i> Back to Offline Patients
    </button>
    
    @if (patient) {
      <div class="patient-header">
        <h1>{{ patient.FirstName }} {{ patient.LastName }}</h1>
        @if (patient.PreferredName) {
          <h4 class="text-muted">({{ patient.PreferredName }})</h4>
        }
        <div class="sync-info">
          <i class="pi pi-clock text-muted"></i>
          <span class="text-muted">Last synced: {{ formatDate(offlineData?.lastSyncTime) }}</span>
        </div>
      </div>
    }
  </div>

  @if (loading) {
    <div class="text-center my-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Loading patient data...</p>
    </div>
  }

  @if (errorMessage) {
    <div class="alert alert-warning" role="alert">
      <strong>Warning:</strong> {{ errorMessage }}
    </div>
  }

  @if (!loading && !errorMessage) {
    <div class="content">
      <!-- Data Summary Section -->
      <div class="card mb-4">
        <div class="card-header">
          <h3 class="mb-0">
            <i class="pi pi-database me-2"></i>
            Offline Data Summary
          </h3>
        </div>
        <div class="card-body">
          <div class="row">
            @for (item of getDataSummary(); track item.label) {
              <div class="col-md-3 col-sm-6 mb-3">
                <div class="data-item">
                  <div class="data-count">{{ item.count }}</div>
                  <div class="data-label">{{ item.label }}</div>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="card-footer"> 
          <button class="btn btn-primary" (click)="removeAllData()">Remove all data</button>
        </div>
      </div>

      <!-- Sessions Section -->
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0">
            <i class="pi pi-list me-2"></i>
            Active Sessions
          </h3>
        </div>
        <div class="card-body">
          @if (offlineData?.sessions?.length === 0) {
            <p class="text-center text-muted my-4">No active sessions available offline.</p>
          } @else {
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Service ID</th>
                    <th>Start Date</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @for (session of offlineData?.sessions; track session.ID) {
                    <tr>
                      <td>{{ session.ServiceID }}</td>
                      <td>{{ formatDate(session.StartedDate) }}</td>
                      <td>
                          {{ getSessionStatus(session) }}
                      </td>
                      <td>
                        <button 
                          class="btn btn-sm"
                          (click)="goToSession(session)"
                        >
                          <i class="pi pi-external-link me-1"></i>
                          Open Session
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div> 